import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface AssignDiscountPayload {
  discount_id: number
}

export interface AssignDiscountResponse {
  message: string
  errors: string[]
}

export function assignDiscountToUser(userId: string, discountId: number): Promise<ApiResponse<AssignDiscountResponse>> {
  return api.post<ApiResponse<AssignDiscountResponse>>(`/discounts/users/assign/${userId}`, { discount_id: discountId })
}
